export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9321.9e43548a.jpg";